appwaiver.controller('MainController', ['$scope', '$http', '$timeout', '$translate', '$sce', '$filter', function ($scope, $http, $timeout, $translate, $sce, $filter) {
    $scope.completed = false;
    $scope.loaded = true;
    $scope.error = false;
    $scope.error500 = false;
    $scope.kidsWaiver = false;

    $scope.waiverInfo = { LoyaltyProgram: false };
    $scope.waiverInfo.Client = {};
    $scope.waiverInfo.Client.LearnedFrom = '';
    $scope.waiverInfo.Client.MedicalConditionField = false;
    $scope.waiverInfo.Client.Medicalconditiontext = '';
    $scope.waiverInfo.Client.SendEmailField = false;
    $scope.waiverInfo.Client.LoyaltyProgram = false;
    $scope.waiverInfo.GymID = GymID;
    $scope.oneLanguageToRuleThemAll = false;
    $scope.waiverInfo.Namespace = namespace;
    $scope.waiverInfo.Client.Sex = null;
    // $scope.waiverInfo.SignaturePicture = signaturePicture;
    $scope.loyaltyProgram = loyaltyProgram;
    $scope.waiverInfo.isOnline = isOnline;
    $scope.legalAge = 21;
    $scope.waiverMinimumAge = 18;
    $scope.memberships = memberships;

    $scope.waiverLockFirstName = false;
    $scope.waiverLockLastName = false;
    $scope.waiverLockEmail = false;
    $scope.waiverLockBirthdate = false;

    var $translateThis = $filter('translate');
    $scope.logo = logo;

    $scope.WaiverMultipleConditions = false;
    $scope.WaiverMultipleConditionsChildren = false;
    $scope.emailFormat = /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-_]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/;
    $scope.phoneFormat = gym[0].Culture.includes('GB') ? /^[0-9]{5,11}$/ : /^[0-9]{5,15}$/;

    if ( legalAge != 0 && legalAge != null ) {
        $scope.legalAge = legalAge;
        $scope.legalAge += 1;
    }

    if (instructors) {
        $scope.instructors = instructors;
    }

    function getLangAbr(lang){
        let newLang;
        if (lang == 'English') {
            newLang = 'en';
        }else if (lang == 'Bulgarian'){
            newLang = 'bg';
        }else if (lang == 'Spanish'){
            newLang = 'es';
        }else if (lang == 'Portuguese'){
            newLang = 'pt';
        }else if(lang == 'Catalan'){
            newLang = 'esc';
        }else if(lang == 'Mexican'){
            newLang = 'esm';
        }else if(lang == 'Italian'){
            newLang = 'it';
        }else if(lang == 'Romanian'){
            newLang = 'ro';
        }else if(lang == 'Lithuanian'){
            newLang = 'lt';
        }else if(lang == 'Indonesian'){
            newLang = 'id';
        }else if(lang == 'German'){
            newLang = 'de';
        }else{
            newLang = 'en';
        }

        return newLang;
    }

    $('#address-input-val').on('keyup', function(){
        var input = $(this);
        val = $(this).val();
        if (val.length > 3) {
            input.addClass('hidden-input');
            $('#address-input').removeClass('hidden-input').val(val).focus();
        }else{
            input.removeClass('hidden-input');
            $('#address-input').addClass('hidden-input')
        }
        $scope.waiverInfo.Client.Address = val;
    })

    $('#address-input').on('keyup', function(){
        var input = $(this);
        val = $(this).val();
        if (val.length > 3) {
            input.removeClass('hidden-input');
            $('#address-input-val').addClass('hidden-input')
        }else{
            input.addClass('hidden-input');
            $('#address-input-val').removeClass('hidden-input').val(val).focus();
        }
        $scope.waiverInfo.Client.Address = val;
    })

    $('#city-input-val').on('keyup', function(){
        var input = $(this);
        val = $(this).val();
        if (val.length > 3) {
            input.addClass('hidden-input');
            $('#city-input').removeClass('hidden-input').val(val).focus();
        }else{
            input.removeClass('hidden-input');
            $('#city-input').addClass('hidden-input')
        }
        $scope.waiverInfo.Client.City = val;
    })

    $('#city-input').on('keyup', function(){
        var input = $(this);
        val = $(this).val();
        if (val.length > 3) {
            input.removeClass('hidden-input');
            $('#city-input-val').addClass('hidden-input')
        }else{
            input.addClass('hidden-input');
            $('#city-input-val').removeClass('hidden-input').val(val).focus();
        }
        $scope.waiverInfo.Client.City = val;
    })

    var currentYear = new Date().getFullYear();
    var endYear = new Date().getFullYear();
    $scope.years = [];
    $scope.yearsKid = [];
    var startYear = new Date();
    var startYearKid = new Date();
    startYear.setFullYear(startYear.getFullYear() - 100);
    startYearKid.setFullYear(startYearKid.getFullYear() - $scope.legalAge);

    startYear = startYear.getFullYear();
    startYearKid = startYearKid.getFullYear();

    while (startYear <= endYear) {
        $scope.years.push(startYear++);
    }

    while (startYearKid <= currentYear) {
        $scope.yearsKid.push(startYearKid++);
    }

    if (showEvents) {
        $scope.showEvents = showEvents;
        $scope.eventsCurrentDay = currentDay;
        $scope.eventsCurrentEvent = eventID;
        $scope.events = events;
        $scope.eventsLength = $scope.events.length;

        var now = new Date();
        var myTimeSpan = 30 * 60 * 1000; // 45 minutes in milliseconds
        now.setTime(now.getTime() - myTimeSpan);

        $scope.events.filter(function (el) { return (el.Date >= now); })
    }

    if (waiver && waiver[0].WaiverRefresh == true) {
        var time = new Date().getTime();
        $(document.body).bind("mousemove keypress touchstart touch", function (e) {
            time = new Date().getTime();
        });

        var timeout = 360000;
        if (waiver[0].WaiverRefreshRate) {
            timeout = waiver[0].WaiverRefreshRate * 1000;
        }

        function refresh() {
            if (new Date().getTime() - time >= timeout) {
                window.location.reload(true);
            } else {
                setTimeout(refresh, timeout);
            }
        }

        setTimeout(refresh, timeout);
    }


    // New Waiver START HERE
    var waiversMainInfo = { Name: '', ID: 0, Languages: [] }
    $scope.waiverPreDefined = false;
    var selectedWav = false;

    $scope.waivers = [];
    $scope.waiverLang = '';

    $.each(waiver, function (index, value) {
        var self = $(this)[0];

        waiversMainInfo = { Name: self.Name, ID: self.Id, Languages: [] }

        $.each(self.Waivers, function () {
            var innerSelf = $(this)[0];
            innerSelf.Language = $translateThis(innerSelf.Language);

            if($scope.waiverInfo.isOnline && innerSelf.AvailableOnlyAtReception){

            }else{
                waiversMainInfo.Languages.push(innerSelf.Language);
            }
        });

        if(waiversMainInfo.Languages.length > 0){
            $scope.waivers.push(waiversMainInfo);
        }

    });

    $scope.waiverStep = 1;

    $scope.nextStep = function (index) {
        $scope.waiverStep = index;
    }

    $scope.prevStep = function (index) {
        if (index < $scope.waiverStep) {
            
            if (index == 1 && !$scope.waiverPreDefined) {
                    $scope.innerWaiver = false;
                    $scope.oneLanguageToRuleThemAll = false;
            }
            $scope.waiverStep = index;
            $scope.objectChoosen = false;
            $scope.waiverInfo.Client = {};
            $scope.waiverInfo.Client.MedicalConditionField = false;
            $scope.waiverInfo.Client.Medicalconditiontext = '';
            $scope.waiverInfo.Client.SendEmailField = false;
            
            $scope.kidsWaiver = false;
            $scope.clearSignature();
            $scope.ready = false;
            $scope.kids = [];
            $scope.resetForm();
        }

        
    }

    $scope.authorizedPersons = [];
    $scope.kids = [];

    $scope.waiverKids = function () {
        $scope.kidsWaiver = true;
        $scope.kid = {};
        
        $scope.kid.Sex = 0;
        $scope.kid.Sex = null;
        $scope.ready = true;

        if(client && client.Kids){
            for (let index = 0; index < client.Kids.length; index++) {
                const kid = client.Kids[index];
                let newKid = {};
                newKid.Name = kid.FirstName;

                if(kid.Birthdate){
                    let date = new Date(kid.Birthdate);
                    let day =  date.getDate();
                    day = day < 10 ? '0'+day : day;
                    let month = date.getMonth() +1;
                    let year = date.getFullYear();
                    
                    newKid.BirthdateChildDay = day.toString();
                    newKid.BirthdateChildMonth = month.toString();
                    newKid.BirthdateChildYear = year.toString();

                    newKid.Sex = client.Female ? 'false' : 'true';
                    newKid.ChildID = kid.ClientID;
                    newKid.Locked = true;
                }
                
                $scope.kids.push(newKid);   
            }

            console.log($scope.kids);

        }else if(!client && $scope.storageObj){
            $scope.kid.Name = $scope.storageObj.ChildFirstName;
            $scope.kid.LastName = $scope.storageObj.ChildLastName;
            $scope.kid.BirthdateChildDay = $scope.storageObj.BirthdateChildDay;
            $scope.kid.BirthdateChildMonth = $scope.storageObj.BirthdateChildMonth;
            $scope.kid.BirthdateChildYear = $scope.storageObj.BirthdateChildYear;
            $scope.kid.Birthday = $scope.kid.BirthdateChildMonth + '/' + $scope.kid.BirthdateChildDay + '/' + $scope.kid.BirthdateChildYear;

            $scope.kids.push($scope.kid);
        }else{
            $scope.kid.Name = '';
            $scope.kid.Birthday = '';

            if ( gamifier ) {
                $scope.kid.PlayerName = '';
                $scope.kid.Rfid = '';
            }

            $scope.kids.push($scope.kid);
        }

        if($scope.innerWaiver.ChildPickUp){
            // $scope.addPerson();
        }

        $scope.waiverStep = 3;

        if (!$scope.WaiverMultipleConditionsChildren) {
            $('.iframe-wrapper').show();
            $('.iframe-wrapper .inner-wrapper').html("<iframe src='" + $scope.innerWaiver.DocumentLinkChildren + "' style=' width: 100%; height: 700px; overflow: hidden;' scrolling='auto'></iframe>");
        }
    }

    $('.iframe-wrapper .arrow').on('click', function(e){
        e.preventDefault();
        $("html, body").animate({ scrollTop: document.body.scrollHeight }, "slow");
    })

    $scope.removePerson = function (i) {
        // if ($scope.authorizedPersons.length > 1)
        $scope.authorizedPersons.splice(i, 1);
    }

    $scope.addPerson = function () {
        $scope.authorizedPerson = {};
        $scope.authorizedPerson.Email = '';
        $scope.authorizedPerson.FirstName = '';
        $scope.authorizedPerson.LastName = '';
        $scope.authorizedPerson.Telephone = '';
        $scope.authorizedPerson.PIN = '';

        $scope.authorizedPersons.push($scope.authorizedPerson);

        setTimeout(function(){
            for (let index = 0; index < $scope.authorizedPersons.length; index++) {
                if((index+1) == $scope.authorizedPersons.length){   
                    const element = $scope.authorizedPersons[index];
                    
                    let input = document.querySelector("#Telephone"+$scope.authorizedPersons.length);
                    element.inputInitPhoneAP = input;
                    element.phoneFormatAP = gym[0].Culture.includes('GB') ? /^[0-9]{5,11}$/ : /^[0-9]{5,15}$/;

                    if(element.inputInitPhoneAP){
                        element.inputPhoneAP = window.intlTelInput(element.inputInitPhoneAP, {
                            autoHideDialCode: false,
                            preferredCountries: [phoneLang],
                            separateDialCode: true
                        });

                        element.inputInitPhoneAP.addEventListener("countrychange", function() {
                            let countryinfo = element.inputPhoneAP.getSelectedCountryData()
                            if(countryinfo.dialCode == '44'){
                                element.phoneFormatAP = /^[0-9]{5,11}$/;
                            }else{
                                element.phoneFormatAP = /^[0-9]{5,15}$/;
                            }
                        });
                    }  
                } 
            }
        }, 100);
    }

    $scope.waiverNoKids = function () {
        $scope.kidsWaiver = false;
        $scope.ready = true;
        $scope.waiverStep = 3;

        if ( gamifier ) {
            $scope.addGamifier();
        }

        if ( !$scope.WaiverMultipleConditions ) {
            $('.iframe-wrapper').show();
            $('.iframe-wrapper .inner-wrapper').html("<iframe src='" + $scope.innerWaiver.DocumentLink + "' style=' width: 100%; height: 700px; overflow: hidden;' scrolling='auto'></iframe>");
        }
    }

    function isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    function translateLanguage(lang){

    }

    function translateWaiver(waiver){
        // this is only needed for one one handed person who can not copy and pasy fast
        // overall the code is bulshit 
        
        if($scope.innerWaiver){

            if($scope.innerWaiver.AddressField == 'AddressField'){
                $scope.innerWaiver.AddressField = $translateThis('AddressField');
            }

            if($scope.innerWaiver.BackField == 'BackField'){
                $scope.innerWaiver.BackField = $translateThis('BackField');
            }

            if($scope.innerWaiver.BirthdateChildField == 'BirthdateChildField'){
                $scope.innerWaiver.BirthdateChildField = $translateThis('BirthdateChildField');
            }

            if($scope.innerWaiver.BirthdateField == 'BirthdateField'){
                $scope.innerWaiver.BirthdateField = $translateThis('BirthdateField');
            }

            if($scope.innerWaiver.ChildName == 'ChildName'){
                $scope.innerWaiver.ChildName = $translateThis('ChildName');
            }

            if($scope.innerWaiver.ChildLastName == 'ChildLastName'){
                $scope.innerWaiver.ChildLastName = $translateThis('ChildLastName');
            }

            if($scope.innerWaiver.CityField == 'CityField'){
                $scope.innerWaiver.CityField = $translateThis('CityField');
            }

            if($scope.innerWaiver.EmailField == 'EmailField'){
                $scope.innerWaiver.EmailField = $translateThis('EmailField');
            }

            if($scope.innerWaiver.FirstNameField == 'FirstNameField'){
                $scope.innerWaiver.FirstNameField = $translateThis('FirstNameField');
            }

            if($scope.innerWaiver.Gender == 'Gender'){
                $scope.innerWaiver.Gender = $translateThis('Gender');
            }

            if($scope.innerWaiver.GenderMaleField == 'GenderMaleField'){
                $scope.innerWaiver.GenderMaleField = $translateThis('GenderMaleField');
            }

            if($scope.innerWaiver.GeneralConditionsField == 'GenderFemaleField'){
                $scope.innerWaiver.GeneralConditionsField = $translateThis('GenderFemaleField');
            }

            if($scope.innerWaiver.AddressField == 'GeneralConditionsField'){
                $scope.innerWaiver.AddressField = $translateThis('GeneralConditionsField');
            }

            // if($scope.innerWaiver.Language == 'Language'){
            //     $scope.innerWaiver.Language = $translateThis('Language');
            // }

            if($scope.innerWaiver.LastNameField == 'LastNameField'){
                $scope.innerWaiver.LastNameField = $translateThis('LastNameField');
            }

            if($scope.innerWaiver.Myself == 'Myself'){
                $scope.innerWaiver.Myself = $translateThis('Myself');
            }

            if($scope.innerWaiver.MyselfAndChildren == 'MyselfAndChildren'){
                $scope.innerWaiver.MyselfAndChildren = $translateThis('MyselfAndChildren');
            }

            if($scope.innerWaiver.PhoneField == 'PhoneField'){
                $scope.innerWaiver.PhoneField = $translateThis('PhoneField');
            }

            if($scope.innerWaiver.PostcodeField == 'PostcodeField'){
                $scope.innerWaiver.PostcodeField = $translateThis('PostcodeField');
            }

            if($scope.innerWaiver.SaveField == 'SaveField'){
                $scope.innerWaiver.SaveField = $translateThis('SaveField');
            }

            if($scope.innerWaiver.ButtonAddChild == 'ButtonAddChild'){
                $scope.innerWaiver.ButtonAddChild = $translateThis('ButtonAddChild');
            }

            if($scope.innerWaiver.ButtonClear == 'ButtonClear'){
                $scope.innerWaiver.ButtonClear = $translateThis('ButtonClear');
            }

            if($scope.innerWaiver.ChooseYourWaiver == 'ChooseYourWaiver'){
                $scope.innerWaiver.ChooseYourWaiver = $translateThis('ChooseYourWaiver');
            }

            if($scope.innerWaiver.ConnectionProblemMessage == 'ConnectionProblemMessage'){
                $scope.innerWaiver.ConnectionProblemMessage = $translateThis('ConnectionProblemMessage');
            }

            if($scope.innerWaiver.ErrorMessage == 'ErrorMessage'){
                $scope.innerWaiver.ErrorMessage = $translateThis('ErrorMessage');
            }

            if($scope.innerWaiver.FillInAllFields == 'FillInAllFields'){
                $scope.innerWaiver.FillInAllFields = $translateThis('FillInAllFields');
            }

            if($scope.innerWaiver.FillInForm == 'FillInForm'){
                $scope.innerWaiver.FillInForm = $translateThis('FillInForm');
            }

            if($scope.innerWaiver.SelectLanguage == 'SelectLanguage'){
                $scope.innerWaiver.SelectLanguage = $translateThis('SelectLanguage');
            }

            if($scope.innerWaiver.SelectType == 'SelectType'){
                $scope.innerWaiver.SelectType = $translateThis('SelectType');
            }

            if($scope.innerWaiver.SelectTypeAndLanguage == 'SelectTypeAndLanguage'){
                $scope.innerWaiver.SelectTypeAndLanguage = $translateThis('SelectTypeAndLanguage');
            }

            if($scope.innerWaiver.SelectWaiver == 'SelectWaiver'){
                $scope.innerWaiver.SelectWaiver = $translateThis('SelectWaiver');
            }

            if($scope.innerWaiver.SuccessMessage == 'SuccessMessage'){
                $scope.innerWaiver.SuccessMessage = $translateThis('SuccessMessage');
            }

            if($scope.innerWaiver.SignatureFieldText == 'SignatureFieldText'){
                $scope.innerWaiver.SignatureFieldText = $translateThis('SignatureFieldText');
            }

        }
    }

    $scope.chooseLanguage = function (lang) {
        var result = $.grep($scope.mainWaiver.Waivers, function (e) { return e.Language == lang; });
        lang = getLangAbr(lang)
        $scope.lang = lang;
        $scope.waiverMinimumAge = 0;
    
        console.log(lang);
        $translate.use(lang);

        if (result.length > 0) {
            $scope.innerWaiver = result[0];
            translateWaiver();
            console.log($scope.innerWaiver);
            $scope.waiverInfo.WaiverID = result[0].ID;

            $scope.waiverInfo.Client.MedicalConditionField = $scope.innerWaiver.MedicalConditionField;
            $scope.waiverInfo.Client.Medicalconditiontext = $scope.innerWaiver.Medicalconditiontext;

            $scope.innerWaiver.MaximumChildrenAllowed = $scope.innerWaiver.MaximumChildrenAllowed != 0 ? $scope.innerWaiver.MaximumChildrenAllowed : 20; 

            if ( $scope.innerWaiver.WaiverMultipleConditions != null ) {
                $scope.WaiverMultipleConditions = true;
                if(isJsonString($scope.innerWaiver.WaiverMultipleConditions)){
                    $scope.innerWaiver.WaiverMultipleConditions = JSON.parse($scope.innerWaiver.WaiverMultipleConditions);
                   
                    for (var i = 0; i < $scope.innerWaiver.WaiverMultipleConditions.length; i++) {
                        $scope.innerWaiver.WaiverMultipleConditions[i].Content = $sce.trustAsHtml($scope.innerWaiver.WaiverMultipleConditions[i].Content);
                    }
                }
            }

            if ( $scope.innerWaiver.WaiverMultipleConditionsChildren != null ) {
                $scope.WaiverMultipleConditionsChildren = true;
                if(isJsonString($scope.innerWaiver.WaiverMultipleConditionsChildren)){
                    $scope.innerWaiver.WaiverMultipleConditionsChildren = JSON.parse($scope.innerWaiver.WaiverMultipleConditionsChildren);

                    for (var i = 0; i < $scope.innerWaiver.WaiverMultipleConditionsChildren.length; i++) {
                        $scope.innerWaiver.WaiverMultipleConditionsChildren[i].Content = $sce.trustAsHtml($scope.innerWaiver.WaiverMultipleConditionsChildren[i].Content);
                    }
                }
            }

            if ($scope.innerWaiver.DocumentName == undefined) {
                $scope.waiverKids();
            }

            if ($scope.innerWaiver.DocumentNameChildren == undefined) {
                $scope.waiverNoKids();
            }

            // if video is required to watch add code here
            if($scope.innerWaiver.MandatoryVideo){
                let videoId = youtube_parser($scope.innerWaiver.VideoLink);
                onYouTubePlayerAPIReady(videoId);
            }

            if(client){
                if(waiverId && client.FirstName){
                    $scope.waiverLockFirstName = true;
                }
                if(waiverId && client.LastName){
                    $scope.waiverLockLastName = true;
                }
                if(waiverId && client.Email){
                    $scope.waiverLockEmail = true;
                }
                $scope.waiverInfo.Client.FirstName = client.FirstName;
                $scope.waiverInfo.Client.LastName = client.LastName;
                $scope.waiverInfo.Client.Email = client.Email;
                $scope.waiverInfo.Client.EmergencyContact = client.EmergencyName;
                $scope.waiverInfo.Client.EmergencyContactPhone = client.EmergancyPhone;
                $scope.waiverInfo.Client.SendEmailField = client.ReceiveEmail;
                $scope.waiverInfo.Client.Medicalconditiontext = client.MedicalCondition;

                if(client.HomeCity && client.HomeAddress){
                    let city = client.HomeCity
                    let splitCity = ' ' + city + ' ';
                    let splitItOut = client.HomeAddress.split(splitCity);
                    let adress = splitItOut[0];
                    let postCode = splitItOut[1];

                    $('#address-input-val').val(adress);
                    $('#city-input-val').val(city);

                    $scope.waiverInfo.Client.Address = adress;
                    $scope.waiverInfo.Client.City = city;
                    $scope.waiverInfo.Client.Postcode = postCode;
                }

                if(client.Birthdate){
                    if(waiverId){
                        $scope.waiverLockBirthdate = true;
                    }
                    let date = new Date(client.Birthdate);
                    let day =  date.getDate();
                    day = day < 10 ? '0'+day : day;
                    let month = date.getMonth() +1;
                    let year = date.getFullYear();
                    
                    $scope.clientBirthdayDay = day.toString();
                    $scope.clientBirthdayMonth = month.toString();
                    $scope.clientBirthdayYear = year.toString();
                    $scope.touchedMain = true;
                }

                console.log(client);

                $timeout(function () {
                    $scope.waiverInfo.Client.Sex = client.Female ? 'false' : 'true';
                })
            }
        } else {
            $scope.innerWaiver = false;
        }
    }

    function youtube_parser(url){
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return (match&&match[7].length==11)? match[7] : false;
    }

    $scope.chooseWaiver = function (id) {
        var result = $.grep(waiver, function (e) { return e.Id == id; });
        $scope.mainWaiver = { Name: result[0].Name, ID: result[0].Id, Duration: result[0].Duration, SubtypeID: result[0].SubtypeID, Waivers: result[0].Waivers, WaiverId: id, RedirectTo: result[0].RedirectTo }
        $scope.mainWaiver = result[0];
        $scope.waiverStep = 2;

        if ( $scope.waiverPreDefined && curLang) {
            $scope.chooseLanguage(curLang)
            $scope.oneLanguageToRuleThemAll = true;
        } else if ($scope.mainWaiver.Waivers.length <= 1) {
            $scope.chooseLanguage($scope.mainWaiver.Waivers[0].Language)
            $scope.oneLanguageToRuleThemAll = true;
        } else {
            $scope.oneLanguageToRuleThemAll = false;
        }

        // $scope.$apply();
    }

    $('.menu-trigger').on('click', function (e) {
        e.preventDefault();

        $('.header').toggleClass('show-menu');
    })

    $('#generalConditionscheck').on('change', function () {
        if ($scope.waiverInfo.Client.GeneralConditions && ($scope.innerWaiver.WaiverPrivacyPolicyEnabled == false || $scope.waiverInfo.Client.PrivacyPolicyAgreed)) {
            var checkbox = $(this);

            if (checkbox.is(':checked')) {
                $("html, body").animate({ scrollTop: 0 }, "slow");
            }
        }
    })

    $('#WaiverPrivacyPolicyEnabledChecked').on('change', function () {
        if ($scope.waiverInfo.Client.GeneralConditions && ($scope.innerWaiver.WaiverPrivacyPolicyEnabled == false || $scope.waiverInfo.Client.PrivacyPolicyAgreed)) {
            var checkbox = $(this);

            if (checkbox.is(':checked')) {
                $("html, body").animate({ scrollTop: 0 }, "slow");
            }
        }
    })

    $(document).on('change', '.document-row .checkbox-field input', function () {
        if ($scope.GeneralConditionsForm.$valid) {
            $("html, body").animate({ scrollTop: 0 }, "slow");
        }
    })

    $scope.resetForm = function () {
        // Set the field values back to the original default values
        $timeout(function () {
            $scope.defaultFormData = angular.copy($scope.resetCopy);
            $scope.waiverForm.$setPristine();
            $scope.waiverForm.$setValidity();
            $scope.waiverForm.$setUntouched();    
        })
        location.reload();
    }
    // New Waiver END HERE

    // if ( gamifier ) {
    //     $scope.gamifier = gamifier;

    //     $scope.gamifierFields = [];

    //     $scope.addGamifier = function () {
    //         $scope.gamifierItem = {};
    //         $scope.gamifierItem.PlayerName = '';
    //         $scope.gamifierItem.Rfid = '';
            
    //         $scope.gamifierFields.push($scope.gamifierItem);
    //     }

    //     $scope.addGamifier();

    //     $scope.removeGamifier = function (i) {
    //         if ($scope.gamifierFields.length > 1)
    //             $scope.gamifierFields.splice(i, 1);
    //     }

    // }

    if ( gamifier ) {
        $scope.gamifier = gamifier;

        $scope.gamifierFields = [];
        
        $scope.addGamifier = function () {
            $scope.gamifierItem = {};
            $scope.gamifierItem.PlayerName = '';
            $scope.gamifierItem.Rfid = '';
            
            $scope.gamifierFields.push($scope.gamifierItem);
        }
        $scope.removeGamifier = function (i) {
            if ($scope.gamifierFields.length > 1)
                $scope.gamifierFields.splice(i, 1);
        }
    }

    $scope.backButton = function () {
        $scope.waiverInfo.Client = {};
        $scope.waiverInfo.Client.MedicalConditionField = false;
        $scope.waiverInfo.Client.Medicalconditiontext = '';
        $scope.waiverInfo.Client.SendEmailField = false;
        $scope.kidsWaiver = false;
        $scope.clearSignature();
        $scope.ready = false;
        $scope.kids = [];
        $scope.kid.Birthday = '';
        $scope.waiverInfo.Client.Birthday = '';
        $scope.resetForm();
    }

    $scope.addChild = function () {
        $scope.kid = {};
        $scope.kid.Name = '';
        $scope.kid.Birthday = '';
        $scope.kid.Sex = 0;
        $scope.kid.Sex = null;
        $scope.kid.LastName = '';
        $scope.kid.BirthPlace = '';
        $scope.kid.PIN = '';
        $scope.kid.ValidBirthday = true;

        if ( gamifier ) {
            $scope.kid.PlayerName = '';
            $scope.kid.Rfid = '';
        }

        $scope.kids.push($scope.kid);
    }

    $scope.updateInstructor = function(){
        $scope.waiverInfo.Client.InstructorName = $('#selectInstructor option:selected').text();
        console.log($scope.waiverInfo.Client.InstructorName);
    }

    // Signature Canvas
    var c = document.getElementById("signature");
    var ctx = c.getContext("2d");
    ctx.clearRect(0, 0, 300, 300);

    $scope.clearSignature = function () {
        var c = document.getElementById("signature");
        var ctx = c.getContext("2d");
        ctx.clearRect(0, 0, 300, 300);
    }

    // Signature Names Canvas
    var c = document.getElementById("signatureNames");
    var ctx = c.getContext("2d");
    ctx.clearRect(0, 0, 300, 300);

    $scope.clearSignatureNames = function () {
        var c = document.getElementById("signatureNames");
        var ctx = c.getContext("2d");
        ctx.clearRect(0, 0, 670, 300);
    }

    // SuperVisor Signature Canvas
    var cSupervisor = document.getElementById("supervisorSignature");
    var ctxSupervisor = cSupervisor.getContext("2d");
    ctxSupervisor.clearRect(0, 0, 300, 300);

    $scope.clearSignatureSupervisor = function () {
        var cSupervisor = document.getElementById("supervisorSignature");
        var ctxSupervisor = cSupervisor.getContext("2d");
        ctxSupervisor.clearRect(0, 0, 300, 300);
    }

    // Instructor Signature Canvas
    var cInstr = document.getElementById("signatureInstr");
    var ctxInstr = cInstr.getContext("2d");
    ctxInstr.clearRect(0, 0, 300, 300);

    $scope.clearSignatureInstr = function () {
        var cInstr = document.getElementById("signatureInstr");
        var ctxInstr = cInstr.getContext("2d");
        ctxInstr.clearRect(0, 0, 300, 300);
    }

    $scope.removeKid = function (i) {
        if ($scope.kids.length > 1)
            $scope.kids.splice(i, 1);
    }

    $scope.errorFalse = function () {
        $scope.error = false;
        $scope.error500 = false;
    }

    // $scope.checkIban = function(){
    //     var BICFromIBAN = require ("BICFromIBAN");
  
    //     // Return true if the IBAN is a correct banck account 
    //     var isValid = BICFromIBAN.validateIBAN("DZ4000400174401001050486");
    // }

    function checkIban(iban){
        Openiban
        .validate(iban)
        .then(function (result) {
            $timeout(function () {
                if ( result.valid ) {
                    $('#sepaIbanCkeckbox:not(:checked)').trigger('click');
                }else{
                    $('#sepaIbanCkeckbox:checked').trigger('click');
                }  
            })
        })
        .catch(function (err) {
          // some http error has occurred
        });
    }

    $(document).on('keyup change', '#iban-field', function(){
        checkIban($(this).val());
    })

    function daysInMonth(m, y) { // m is 0 indexed: 0-11
        switch (m) {
            case 1:
                return (y % 4 == 0 && y % 100) || y % 400 == 0 ? 29 : 28;
            case 8: case 3: case 5: case 10:
                return 30;
            default:
                return 31
        }
    }

    function isValid(d, m, y) {
        return m >= 0 && m < 12 && d > 0 && d <= daysInMonth(m, y);
    }

    function checkAges(date) {
        if ($scope.innerWaiver.WaiverMinimumAge != 0) {
            $scope.waiverMinimumAge = $scope.innerWaiver.WaiverMinimumAge;
        }

        var currentYear = new Date().getFullYear();
        var minDate = new Date();
        minDate.setFullYear(currentYear - $scope.waiverMinimumAge);
        minDate.setHours(0, 0, 0, 0);
        checkDate = new Date(date);
        checkDate.setHours(0, 0, 0, 0);

        if (checkDate <= minDate) {
            $scope.readyToSendMainAdult = true;
        } else {
            $scope.readyToSendMainAdult = false;
            $scope.loaded = true;
        }
    }

    function checkKidAges(date, kidID) {
        var currentYear = new Date().getFullYear();
        var minDate = new Date();
        minDate.setFullYear(currentYear - $scope.legalAge);
        minDate.setHours(0, 0, 0, 0);

        checkDate = new Date(date);
        checkDate.setHours(0, 0, 0, 0);

        if (checkDate >= minDate) {
            $scope.readyToSendKid = true;
            $scope.kids[kidID].ValidBirthdayAges = true;
        } else {
            $scope.loaded = true;
            $scope.readyToSendKid = false;
            $scope.kids[kidID].ValidBirthdayAges = false;
        }
    }

    $scope.readyToSendKid = true;
    $scope.readyToSendMain = true;
    $scope.readyToSendMainAdult = true;
    $scope.touchedMain = false;
    $scope.touchedChild = false;
    $scope.readyToSendSuper = true;
    $scope.touchedSupervisor = false;

    $(document).on('change', '.birthdaymain-fields select', function () {
        $scope.touchedMain = true;
    });
    $(document).on('change', '.birthdaychild-fields select', function () {
        $scope.touchedChild = true;
    });
    $(document).on('change', '.birthdaysuper-fields select', function () {
        $scope.touchedSupervisor = true;
    });

    $(document).on('change', '.birthdaychild-fields select[name="BirthdateChildYear"]', function () {
        var yearVal = parseInt($(this).val());
        var parentWrap = $(this).parents('.child-wrap');
        parentWrap.removeClass('show-alert');

        if ($scope.innerWaiver.WaiverParentRequiredAge != 0) {
            var currentYear = new Date().getFullYear();
            var minYear = parseInt(currentYear - $scope.innerWaiver.WaiverParentRequiredAge)
            $timeout(function () {
                if (yearVal >= minYear) {
                    parentWrap.addClass('show-alert');
                } else {
                    parentWrap.removeClass('show-alert');
                }
            })
        }
    });
    $scope.sendwaiver = function () {
        var signatureReady = false;

        if ( $scope.innerWaiver.InstructorWaiver == true ) {
            var signatureInstrReady = false;
            if ( !isCanvasBlank(document.getElementById("signatureInstr")) ) {
                $('.signatureInstr-wrapper').removeClass('invalid');
                signatureInstrReady = true;
            }else{
                $('.signatureInstr-wrapper').addClass('invalid');
                signatureInstrReady = false;
            }
        }

        if ( $scope.innerWaiver.SupervisedWaiver == true ) {
            var signatureSupervisorReady = false;
            if ( !isCanvasBlank(document.getElementById("supervisorSignature")) ) {
                $('.signatureSupervisor-wrapper').removeClass('invalid');
                signatureSupervisorReady = true;
            }else{
                $('.signatureSupervisor-wrapper').addClass('invalid');
                signatureSupervisorReady = false;
            }
        }

        if ( $scope.innerWaiver.SignaturePictureNamesField ) {
            var signatureNamesReady = false;
            if ( !isCanvasBlank(document.getElementById("signatureNames")) ) {
                $('.signatureNames-wrapper').removeClass('invalid');
                signatureNamesReady = true;
            }else{
                $('.signatureNames-wrapper').addClass('invalid');
                signatureNamesReady = false;
            }
        }

        if (!isCanvasBlank(document.getElementById("signature"))) {
            $('.signature-wrapper').removeClass('invalid');
            signatureReady = true;
        }else{
            $('.signature-wrapper').addClass('invalid');
            signatureReady = false;
        }

        if ( $scope.innerWaiver.InstructorWaiver == true ) {
            if ( signatureReady && signatureInstrReady ) {
                send()
            }
        }else if($scope.innerWaiver.SupervisedWaiver == true){
            if ( signatureReady && signatureSupervisorReady ) {
                send()
            }
        }else if($scope.innerWaiver.SignaturePictureNamesField){
            if (signatureReady && signatureNamesReady) {
                send()
            }
        }else{
            if (signatureReady) {
                send()
            }
        }
    }

    function send(){
        if ( $scope.showCamera && !$scope.waiverInfo.Client.ClientPicture ) {
            $scope.takeSnapshot();
        }
        var currentYear = new Date().getFullYear();
        $scope.waiverInfo.Client.Address = $('#address-input').val();
        $scope.waiverInfo.Client.City = $('#city-input').val();
        $scope.waiverInfo.Client.Telephone = $scope.inputPhone.selectedDialCode.innerHTML + $scope.inputPhone.telInput.value;
        $scope.waiverInfo.Client.Telephone = $scope.waiverInfo.Client.Telephone.replace(/ /g,'');

        $scope.waiverInfo.Client.EmergencyContactPhone = $scope.inputEmergencyTelephone.selectedDialCode.innerHTML + $scope.inputEmergencyTelephone.telInput.value;
        $scope.waiverInfo.Client.EmergencyContactPhone = $scope.waiverInfo.Client.EmergencyContactPhone.replace(/ /g,'');


        $scope.waiverInfo.Client.AuthorizedPersons = $scope.authorizedPersons;
        if($scope.waiverInfo.Client.AuthorizedPersons.length){
            for(var index = 0; index < $scope.waiverInfo.Client.AuthorizedPersons.length; index++){
                let person = $scope.waiverInfo.Client.AuthorizedPersons[index];
                if(person.TelephoneT){
                    let tempNum = $('#pickupTelephone'+$scope.waiverInfo.Client.AuthorizedPersons.length).find('.iti__selected-dial-code')[0].outerText;
                    let telephone = tempNum + person.TelephoneT;
                    person.Telephone =telephone.replace(/ /g,'');
                }
            }
        }

        $scope.sending = true;

        if ($scope.loaded == true) {
            $scope.loaded = false;

             for (var key = 0; key < $scope.kids.length; key++) {
                if ($scope.innerWaiver.BirthdayChildEnabled && $scope.touchedChild) {
                    if (isValid($scope.kids[key].BirthdateChildDay, $scope.kids[key].BirthdateChildMonth - 1, $scope.kids[key].BirthdateChildYear)) {
                        $scope.kids[key].Birthday = $scope.kids[key].BirthdateChildMonth + '/' + $scope.kids[key].BirthdateChildDay + '/' + $scope.kids[key].BirthdateChildYear;
                        $scope.kids[key].Birthday = moment($scope.kids[key].Birthday).format("YYYY-MM-DDTHH:mm:ss");
                        checkKidAges($scope.kids[key].Birthday, [key]);
                        // $scope.readyToSendKid = true;
                        $scope.kids[key].ValidBirthday = true;
                    } else {
                        $scope.loaded = true;
                        $scope.readyToSendKid = false;
                        $scope.kids[key].ValidBirthday = false;
                    }
                }
            }

            if ($scope.innerWaiver.BirthdateEnabled && $scope.touchedMain) {
                if (isValid($scope.clientBirthdayDay, $scope.clientBirthdayMonth - 1, $scope.clientBirthdayYear)) {
                    $scope.readyToSendMain = true;
                    $scope.waiverInfo.Client.Birthday = $scope.clientBirthdayMonth + '/' + $scope.clientBirthdayDay + '/' + $scope.clientBirthdayYear;
                    $scope.waiverInfo.Client.Birthday = moment($scope.waiverInfo.Client.Birthday).format("YYYY-MM-DDTHH:mm:ss");
                    checkAges($scope.waiverInfo.Client.Birthday);
                } else {
                    $scope.loaded = true;
                    $scope.readyToSendMain = false;
                }
            }

            if ($scope.innerWaiver.SupervisedWaiver && $scope.touchedSupervisor) {
                if (isValid($scope.supervisorBirthdayDay, $scope.supervisorBirthdayMonth - 1, $scope.supervisorBirthdayYear)) {
                    $scope.readyToSendSuper = true;
                    $scope.waiverInfo.Client.SupervisorBirthdate = $scope.supervisorBirthdayMonth + '/' + $scope.supervisorBirthdayDay + '/' + $scope.supervisorBirthdayYear;
                    $scope.waiverInfo.Client.SupervisorBirthdate = moment($scope.waiverInfo.Client.SupervisorBirthdate).format("YYYY-MM-DDTHH:mm:ss");
                    checkAges($scope.waiverInfo.Client.SupervisorBirthdate);
                } else {
                    $scope.loaded = true;
                    $scope.readyToSendSuper = false;
                }
            }

            $scope.waiverInfo.Client.Kids = $scope.kids;

            var resultValidBirthday = $.grep($scope.waiverInfo.Client.Kids, function (e) { return e.ValidBirthday == false; });
            var resultValidBirthdayAges = $.grep($scope.waiverInfo.Client.Kids, function (e) { return e.ValidBirthdayAges == false; });
            if (resultValidBirthday.length > 0 || resultValidBirthdayAges.length > 0) {
                $scope.readyToSendKid = false;
            }

            var image = document.getElementById("signature").toDataURL("image/png");
            $scope.waiverInfo.Client.Signature = image;
            var imageInstr = document.getElementById("signatureInstr").toDataURL("image/png");
            $scope.waiverInfo.Client.InstructorSignature = imageInstr;
            var imageSupervisor = document.getElementById("supervisorSignature").toDataURL("image/png");
            $scope.waiverInfo.Client.SupervisorSignature = imageSupervisor;
            var imageNames = document.getElementById("signatureNames").toDataURL("image/png");
            $scope.waiverInfo.Client.SignaturePictureNames = imageNames;

            $scope.waiverInfo.kidsWaiver = $scope.kidsWaiver;
            $scope.waiverInfo.BirthdayID = $('#birthdayevent').val();
            $scope.waiverInfo.Client.LoyaltyProgram = $scope.waiverInfo.LoyaltyProgram;
            
            if ($scope.readyToSendKid == true && $scope.readyToSendMain == true && $scope.readyToSendMainAdult == true && $scope.readyToSendSuper) {
                $http.post('/waiver/SignWaiver', $scope.waiverInfo)
                    .then(function successCallback(d) {
                        $scope.completed = true;
                        $scope.loaded = true;

                        postMessage("sendWaiver", "*");
                        
                        if ( kioskRedirect == true ) {
                            var kioskHref =  window.location.origin + '/OnlineBooking/KioskBooking?GymID=' + GymID + '&NameSpace=' + namespace;
                            window.location.href = kioskHref;
                        }else if (redirect){
                            if( sessionStorage.getItem('urlParams') ){
                                let params = sessionStorage.getItem('urlParams');
                                var href =  window.location.origin + redirect + params;
                            }else{
                                let check = redirect.split("ID=");
                                let gymID = $scope.storageObj.GymID ? $scope.storageObj.GymID : GymID;

                                if (check.length > 1){
                                    var href =  window.location.origin + check[0] + '?GymID=' + gymID + '&NameSpace=' + namespace + '&ID=' + check[1] + '&Redirected=true';
                                }else{
                                    var href =  window.location.origin + redirect + '?GymID=' + gymID + '&NameSpace=' + namespace + '&Redirected=true';   
                                    if(redirect == "/membership/buyV2"){
                                        href += '&initialPayment=true'
                                    }
                                    if($scope.storageObj.MembershipID){
                                        href += '&MembershipID=' + $scope.storageObj.MembershipID;
                                    }
                                    if($scope.storageObj.zoneID){
                                        href += '&selectedGym=' + $scope.storageObj.zoneID;
                                    }
                                    if($scope.storageObj.userID){
                                        href += '&UserID=' + $scope.storageObj.userID;
                                    }
                                    
                                }
                            }
                            window.location.href = href;
                        }else{
                            $timeout(function () {
                                if ($scope.innerWaiver.RedirectTo != undefined && $scope.innerWaiver.RedirectTo != '' && $scope.innerWaiver.RedirectTo != null && isOnline == true) {
                                    window.location.href = $scope.innerWaiver.RedirectTo;
                                    return;
                                }

                                let href = window.location.origin + window.location.pathname + '?GymID=' + GymID + '&NameSpace=' + namespace
                                window.location.href = href;
                            }, 1000)
                        }

                    }, function errorCallback(d) {
                        if (d.status == 500) {
                            $scope.error500 = true;
                        }
                        $scope.completed = false;
                        $scope.loaded = true;
                        $scope.sending = false;
                        $scope.error = true;
                    });
            }
        }
        $scope.sending = false;
    }
    $scope.showCamera = showCamera;

    if ($scope.showCamera) {
        Webcam.set({
            width: 320,
            height: 240,
            image_format: 'jpeg',
            jpeg_quality: 90
        });
        Webcam.attach( '#my_camera' );

        $scope.takeSnapshot = function(){
            // take snapshot and get image data
            Webcam.snap( function(data_uri) {
            // display results in page
                document.getElementById('results').innerHTML = 
                '<img src="'+data_uri+'"/>';
                $scope.waiverInfo.Client.ClientPicture = data_uri;
            } );
        }

        Webcam.on( 'error', function(err) {
            $scope.showCamera = false;
        } );
    }

    function isCanvasBlank(canvas) {
        var blank = document.createElement('canvas');
        blank.width = canvas.width;
        blank.height = canvas.height;

        var blankctxInstr = blank.getContext("2d");
        blankctxInstr.clearRect(0, 0, 300, 300);

        return canvas.toDataURL() == blank.toDataURL();
    }

    if (window.location.hash) {
        var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
        var hashes = hash.split('=');

        if (hashes[0] == 'WavID') {
            selectedWav = hashes[1];

            $scope.waiverPreDefined = true;
            $scope.chooseWaiver(selectedWav);
        }
    }else if($scope.waivers.length == 1){
        $scope.chooseWaiver($scope.waivers[0].ID)
    }


    // Get Language from backend settings
	function getLanguage(culture){
        let lang = culture.split('-');
		lang = lang[1].toLowerCase();
		return lang;
	}

    
    function getStorage() {
        $scope.storageObj = JSON.parse(sessionStorage.storageinfo);
        $timeout(()=>{
            $scope.waiverInfo.Client.FirstName = $scope.storageObj.FirstName;
            $scope.waiverInfo.Client.LastName = $scope.storageObj.LastName;
            $scope.waiverInfo.Client.Email = $scope.storageObj.Email;
        })

        console.log($scope.storageObj);
    }

    // video script goes here
        
        // create player
        var youtubevideo;
        function onYouTubePlayerAPIReady(videoId) {
            youtubevideo = new YT.Player('youtubevideo', {
            height: '390',
            width: '640',
            videoId: videoId,
            //Here the video autoplays, the player hide controls and disable keyboard to prevent users from running past the video. NB: Autoplay only works on PCs. iOS 8 also forces Native controls.
            playerVars:{'rel':0,'showinfo':0,'controls':0,'disablekb':1,'modestbranding':1},
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
            });
        }

        function onPlayerReady(event) {
            // event.target.playVideo();
        }
        //This tells the youtube player to trigger the whenTheVideoStops() function when done watching the video
        
        function onPlayerStateChange(event) {        
            if(event.data === 0) {            
                whenTheVideoStops();
            }
        }
        //THe whenTheVideoStops function uses ajax to bring up html after the video ends. It is achieved using jquery DOM manupulation
        function whenTheVideoStops(){$('#generalConditionscheckVideo').trigger('click');}
    // video script ends here

    let phoneLang = getLanguage(gym[0].Culture);

    $(window).on('load', function(){

        if(!client && sessionStorage.storageinfo){
            getStorage();
        }

        let phoneLang = getLanguage(gym[0].Culture);
        var inputInitPhone = document.querySelector("#Telephone");

        
        if(inputInitPhone){
            $scope.inputPhone = window.intlTelInput(inputInitPhone, {
                autoHideDialCode: false,
                preferredCountries: [phoneLang],
                separateDialCode: true
            });

            if(client){
                $scope.inputPhone.setNumber(client.Telephone);

                $timeout(()=>{
                    $scope.waiverInfo.Client.TelephoneT =  $scope.inputPhone.telInput.value;
                })
            }else if($scope.storageObj && $scope.storageObj.Telephone){

                var teltemp = $scope.storageObj.TelCode + $scope.storageObj.Telephone;
                $scope.inputPhone.setNumber(teltemp);

                $timeout(function () {
                    $scope.waiverInfo.Client.TelephoneT = $scope.storageObj.Telephone;
                })
            }

            inputInitPhone.addEventListener("countrychange", function() {
                let countryinfo = $scope.inputPhone.getSelectedCountryData()
                if(countryinfo.dialCode == '44'){
                    $scope.phoneFormat = /^[0-9]{5,11}$/;
                    $scope.waiverForm.Telephone.$validate()
                }else{
                    $scope.phoneFormat = /^[0-9]{5,15}$/;
                    $scope.waiverForm.Telephone.$validate()
                }
            });
        }

        var inputInitEmergencyTelephone = document.querySelector("#EmergencyTelephone");
        if(inputInitEmergencyTelephone){
            $scope.inputEmergencyTelephone = window.intlTelInput(inputInitEmergencyTelephone, {
                autoHideDialCode: false,
                preferredCountries: [phoneLang],
                separateDialCode: true
            });

            if(client){
                $scope.inputEmergencyTelephone.setNumber(client.Telephone);

                $timeout(()=>{
                    $scope.waiverInfo.Client.EmergencyContactPhoneT =  $scope.inputEmergencyTelephone.telInput.value;
                })
            }

            inputInitEmergencyTelephone.addEventListener("countrychange", function() {
                let countryinfo = $scope.inputEmergencyTelephone.getSelectedCountryData()
                if(countryinfo.dialCode == '44'){
                    $scope.phoneFormat = /^[0-9]{5,11}$/;
                    $scope.waiverForm.EmergencyTelephone.$validate()
                }else{
                    $scope.phoneFormat = /^[0-9]{5,15}$/;
                    $scope.waiverForm.EmergencyTelephone.$validate()
                }
            });
        }

        var countrySelect = document.querySelector("#dropdown-country");
        if(countrySelect){
            for (var i = 0; i < $scope.allCountries.length; i++) {
                $scope.allCountries[i].image = 'https://cdn.jsdelivr.net/npm/svg-country-flags@1.2.10/svg/' + $scope.allCountries[i].value.toLowerCase() + '.svg';
            }
             
            var countryDD = jSuites.dropdown(document.getElementById('dropdown-country'), {
                data: $scope.allCountries,
                autocomplete: true,
                width: '315px',
                onchange: function(el,val) {
                    let resValue = val.value;
                    if(isObjEmpty(resValue)){
                        $('#nationalityCheckboxField:checked').trigger('click');
                        $scope.waiverInfo.Client.Country = undefined;
                    }else{
                        let val = Object.values(resValue);
                        $('#nationalityCheckboxField:not(:checked)').trigger('click');
                        $scope.waiverInfo.Client.Country = val[0];
                    }
        
                }
            });
        
            if(currentCountry){
                const result = $scope.allCountries.find(({ text }) => text === currentCountry);
                countryDD.setValue(result.value);
                $scope.waiverInfo.Client.Country = result.text;
                $('#nationalityCheckboxField').prop("checked", true);
            }
        }
    })

    if(countries){
        $scope.allCountries = [];
        for (const [key, value] of Object.entries(countries)) {
            if(key != '001' && key != '029' && key != '419'){
                let obj = {text: value, value: key};
                $scope.allCountries.push(obj)
            }
        }
    }

    function isObjEmpty (obj) {
        return Object.keys(obj).length === 0;
    }    
}]);


var dictBG = {
    SAVE: "Запази",
    BACK: "Назад",
    NAME: "Име:",
    ADDRESS: "Адрес:",
    WAIVER: "Декларация",
    WAIVERTEXT: "Благодарим, че ни посетихте! <br /> Тук можете да подпишете вашето информирано съгласие електронно. <br /> Трябва да сте на минимум 14 годишна възраст, за да можете да подпишете информирано съгласие! <br /> Ако сте на възраст под 14 години, моля помолете Вашия родител или настойник да подпише съгласието за Вас!",
    MYSELF: "Самостоятелно",
    MYSELFCHILDREN: "За мен & децата",
    IAGREE: "Съгласен съм с тези общи условия",
    FIRSTNAME: "Име",
    LASTNAME: "Фамилия",
    CITY: "Град",
    PHONE: "Телефон",
    CHILDNAME: "Име на детето",
    AGE: "Възраст",
    BIRTDATE: "Рожденна дата:",
    SEX: "Пол",
    ADDCHILD: "Добави дете",
    CLEAR: "Изчисти",
    LOADING: "Зареждане...",
    THANKYOU: "Благодарим, че подписахте тази декларация!",
    SIGNHERE: "Подпишете тук",
    SIGNHERE: "SIGN HERE",
    Sorry: "Моля свържете се и опитайте отново.",
    Oops: "Опа! <br />Връзката с Интернет беше прекъсната.",
    Sorry500: "Съжаляваме. Моля, опитайте отново.",
    Oops500: "Опа! <br />Нещо се обърка.",
    MoveOn: "Продължи",
    orderNotes: "Бележка към поръчката",
    ChooseEvent: "Моля, попълнете всички fieldsChoose рожден ден или събитие",
    tooltiptext: "Ако посетите рожден ден или събитие, моля, изберете кой от списъка",
    CreateFullProfile: "Настройка за създаване на основни профили при подписване на групов уейвър",
    EnterValidDate: "Моля въведете коректна дата!",
    EnterValidDateAdult: "За да попълните декларацията трябва да сте поне на",
    EnterValidDateAdultEnd: "години!",
    EnterValidDateKidAges: "Детето трябва да е по-малко от",
    PlayerName: "Име на играча",
    ParentPlayerName: "Име на играча",
    January: "Януари",
    February: "Февруари",
    March: "Март",
    April: "Април",
    May: "Май",
    June: "Юни",
    July: "Юли",
    August: "Август",
    September: "Септември",
    October: "Октомври",
    November: "Ноември",
    December: "Декември",
    'Fill in a Form':'Попълнете формуляр',
    'Select Waiver':'Изберете декларация',
    'Select Type & Language':'Изберете тип и език',
    'Choose your Waiver!': 'Декларация за информирано съгласие',
    'Select Language': 'Изберете език',
    'Select Type': 'Избери вид',
    'Myself': 'За мен',
    'Myself and Children': 'За мен и моето дете',
    'Back': 'Назад',
    "Please enter a valid number": "Моля въведете валиден номер",
    "AddressField": "Адрес",
    "BackField": "Обратно",
    "BirthdateChildField": "Рождена дата на детето",
    "BirthdateField": "Дата на раждане",
    "ChildName": "Име на детето",
    "ChildLastName": "Фамилия на детето",
    "CityField": "Град",
    "EmailField": "Имейл",
    "FirstNameField": "Собствено име",
    "Gender": "Пол",
    "GenderMaleField": "Мъж",
    "GenderFemaleField": "Жена",
    "GeneralConditionsField": "Моля попълнете декларация, за да ползвате съоръженията в залата.",
    "Language": "Bulgarian",
    "LastNameField": "Фамилно име",
    "Myself": "Аз съм пълнолетен",
    "MyselfAndChildren": "Аз съм родител/настойник",
    "PhoneField": "Телефон",
    "PostcodeField": "Post code",
    "SaveField": "Запази",
    "ButtonAddChild": "Добави дете",
    "ButtonClear": "Изчисти",
    "ChooseYourWaiver": "Изберете декларация",
    "ConnectionProblemMessage": "Връзката със сървъра беше неуспешна. Моля проверете Вашата връзка с Интернет!",
    "ErrorMessage": "Имаше грешка при изпращането на декларацията. Моля обърнете се към рецепция!",
    "FillInAllFields": "Моля попълнете всички полета!",
    "FillInForm": "Попълнете форма",
    "SelectLanguage": "Изберете език",
    "SelectType": "Изберете тип",
    "SelectTypeAndLanguage": "Изберете тип и език",
    "SelectWaiver": "Изберете декларация",
    "SuccessMessage": "Попълването на декларацията беше успешно!",
    "SignatureFieldText": "Подпис"
}


var dictEN = {
    SAVE: "Save",
    BACK: "Back",
    NAME: "Name:",
    ADDRESS: "Address:",
    WAIVER: "Waiver",
    WAIVERTEXT: "Thank you for visiting! <br /> This process will allow you to digitally sign your liability waiver. <br /> note that you must be at least 18<br /> years old in order to sign a liability waiver. If you are not 18<br /> years old, please ask your parent or legal guardian to complete this procedure.",
    MYSELFCHILDREN: "Myself & Children",
    IAGREE: "I agree with these general conditions",
    FIRSTNAME: "First Name",
    LASTNAME: "Last Name",
    CITY: "City",
    PHONE: "Phone",
    CHILDNAME: "Child's name",
    AGE: "Age",
    BIRTDATE: "Brithday date",
    SEX: "Sex",
    ADDCHILD: "Add Child",
    CLEAR: "Clear",
    LOADING: "Loading...",
    THANKYOU: "Thank you for signing the waiver!",
    SIGNHERE: "SIGN HERE",
    Sorry: "Please reconnect and try again.",
    Oops: "Oops! <br />Wi-Fi connection lost.",
    Sorry500: "We're sorry. Please try again.",
    Oops500: "Oops! <br />Something went wrong.",
    MoveOn: "Continue",
    orderNotes: "Order Notes",
    ChooseEvent: "Choose a birthday party or event",
    tooltiptext: "If you will attend a Birthday party or event, please choose which one from the list",
    CreateFullProfile: "Setup to create basic profiles when signing a group waiver",
    EnterValidDate: "Enter a valid date!",
    EnterValidDateAdult: "In order to complete the declaration, you must be at least",
    EnterValidDateAdultEnd: "years old!",
    EnterValidDateKidAges: "Children must be under",
    PlayerName: "Player Name",
    ParentPlayerName: "Parent Player Name",
    'Fill in a Form':'Fill in a Form',
    'Select Waiver':'Select Waiver',
    'Select Type & Language':'Select Type & Language',
    'Choose your Waiver!': 'Choose your Waiver!',
    'Select Language': 'Select Language',
    'Select Type': 'Select Type',
    'Myself': 'Myself',
    'Myself and Children': 'Myself and Children',
    'Back': 'Back',
    "Please enter a valid number": "Please enter a valid number",
    "AddressField": "Address",
    "BackField": "Back",
    "BirthdateChildField": "Child Birthdate",
    "BirthdateField": "Birthdate",
    "ChildName": "Child Name",
    "ChildLastName": "Child Last Name",
    "CityField": "City",
    "EmailField": "Email",
    "FirstNameField": "First Name",
    "Gender": "Gender",
    "GenderMaleField": "Male",
    "GenderFemaleField": "Female",
    "GeneralConditionsField": "Please fill out a declaration to use the facilities in the hall.",
    "LastNameField": "Last Name",
    "Myself": "Myself",
    "MyselfAndChildren": "Myself and Children",
    "PhoneField": "Phone",
    "PostcodeField": "Post code",
    "SaveField": "Save",
    "ButtonAddChild": "Add Child",
    "ButtonClear": "Clear",
    "ChooseYourWaiver": "Choose your Waiver",
    "ConnectionProblemMessage": "The connection to the server was unsuccessful. Please check your Internet connection!",
    "ErrorMessage": "There was an error sending the declaration. Please contact reception!",
    "FillInAllFields": "Please fill in all fields!",
    "FillInForm": "Fill out a form",
    "SelectLanguage": "Select Language",
    "SelectType": "Select Type",
    "SelectTypeAndLanguage": "Select Type and Language",
    "SelectWaiver": "Select Waiver",
    "SuccessMessage": "Filling out the declaration was successful!",
    "SignatureFieldText": "Signature",
}

var dictES = {
    SAVE: "Save",
    BACK: "Back",
    NAME: "Name:",
    ADDRESS: "Address:",
    WAIVER: "Waiver",
    WAIVERTEXT: "Thank you for visiting! <br /> This process will allow you to digitally sign your liability waiver. <br /> note that you must be at least 18<br /> years old in order to sign a liability waiver. If you are not 18<br /> years old, please ask your parent or legal guardian to complete this procedure.",
    MYSELFCHILDREN: "Myself & Children",
    IAGREE: "I agree with these general conditions",
    FIRSTNAME: "First Name",
    LASTNAME: "Last Name",
    CITY: "City",
    PHONE: "Phone",
    CHILDNAME: "Child's name",
    AGE: "Age",
    BIRTDATE: "Brithday date",
    SEX: "Sex",
    ADDCHILD: "Add Child",
    CLEAR: "Clear",
    LOADING: "Loading...",
    THANKYOU: "Thank you for signing the waiver!",
    SIGNHERE: "SIGN HERE",
    Sorry: "Please reconnect and try again.",
    Oops: "Oops! <br />Wi-Fi connection lost.",
    Sorry500: "We're sorry. Please try again.",
    Oops500: "Oops! <br />Something went wrong.",
    MoveOn: "Continue",
    orderNotes: "Order Notes",
    ChooseEvent: "Choose a birthday party or event",
    tooltiptext: "If you will attend a Birthday party or event, please choose which one from the list",
    CreateFullProfile: "Setup to create basic profiles when signing a group waiver",
    EnterValidDate: "¡Introduzca una fecha válida!",
    EnterValidDateAdult: "Para completar la declaración, debe ser al menos",
    EnterValidDateAdultEnd: "¡años!",
    EnterValidDateKidAges: "Los niños deben estar bajo",
    PlayerName: "Nombre del jugador",
    ParentPlayerName: "Parent Player Name",
    January: "enero",
    February: "febrero",
    March: "marzo",
    April: "abril",
    May: "mayo",
    June: "junio",
    July: "julio",
    August: "agosto",
    September: "septiembre",
    October: "octubre",
    November: "noviembre",
    December: "diciembre",
    'Fill in a Form':'Rellenar el formulario',
    'Select Waiver':'Seleccionar consentimiento informado',
    'Select Type & Language':'Seleccione tipo',
    'Choose your Waiver!': 'CONSENTIMIENTO INFORMADO',
    'Select Language': 'Elige tu idioma',
    'Select Type': 'Selecciona una de las siguientes opciones',
    'Myself': 'Adulto',
    'Myself and Children': 'Adulto y menor',
    'Back': 'Atrás',
    "Please enter a valid number": "por favor ingrese un número valido",
    "AddressField": "Dirección",
    "BackField": "Atrás",
    "BirthdateChildField": "Fecha de nacimiento del niño",
    "BirthdateField": "Fecha de nacimiento",
    "ChildName": "Nombre del niño",
    "ChildLastName": "Apellido del niño",
    "CityField": "Ciudad",
    "EmailField": "Correo electrónico",
    "FirstNameField": "Nombre",
    "Gender": "Género",
    "GenderMaleField": "Hombre",
    "GenderFemaleField": "Mujer",
    "GeneralConditionsField": "Por favor, complete la declaración para usar las instalaciones.",
    "Language": "Español",
    "LastNameField": "Apellido",
    "Myself": "Soy mayor de edad",
    "MyselfAndChildren": "Soy padre/madre o tutor legal",
    "PhoneField": "Teléfono",
    "PostcodeField": "Código postal",
    "SaveField": "Guardar",
    "ButtonAddChild": "Añadir niño",
    "ButtonClear": "Limpiar",
    "ChooseYourWaiver": "Elija una declaración",
    "ConnectionProblemMessage": "Conexión con el servidor fallida. ¡Por favor, verifique su conexión a Internet!",
    "ErrorMessage": "Hubo un error al enviar la declaración. ¡Por favor, contacte con la recepción!",
    "FillInAllFields": "¡Por favor, complete todos los campos!",
    "FillInForm": "Complete el formulario",
    "SelectLanguage": "Seleccione idioma",
    "SelectType": "Seleccione tipo",
    "SelectTypeAndLanguage": "Seleccione tipo e idioma",
    "SelectWaiver": "Seleccione declaración",
    "SuccessMessage": "¡La declaración se completó con éxito!",
    "SignatureFieldText": "Firma"
}

var dictESC = {
    SAVE: "Save",
    BACK: "Trona",
    NAME: "Nom:",
    ADDRESS: "Address:",
    WAIVER: "Waiver",
    WAIVERTEXT: "Thank you for visiting! <br /> This process will allow you to digitally sign your liability waiver. <br /> note that you must be at least 18<br /> years old in order to sign a liability waiver. If you are not 18<br /> years old, please ask your parent or legal guardian to complete this procedure.",
    MYSELFCHILDREN: "Myself & Children",
    IAGREE: "I agree with these general conditions",
    FIRSTNAME: "First Name",
    LASTNAME: "Last Name",
    CITY: "City",
    PHONE: "Telèfon",
    CHILDNAME: "Child's name",
    AGE: "Age",
    BIRTDATE: "Brithday date",
    SEX: "Sex",
    ADDCHILD: "Add Child",
    CLEAR: "Clear",
    LOADING: "Cargant...",
    THANKYOU: "Thank you for signing the waiver!",
    SIGNHERE: "SIGN HERE",
    Sorry: "Please reconnect and try again.",
    Oops: "Oops! <br />Wi-Fi connection lost.",
    Sorry500: "We're sorry. Please try again.",
    Oops500: "Oops! <br />Something went wrong.",
    MoveOn: "Continue",
    orderNotes: "Comandes",
    ChooseEvent: "Choose a birthday party or event",
    tooltiptext: "If you will attend a Birthday party or event, please choose which one from the list",
    CreateFullProfile: "Setup to create basic profiles when signing a group waiver",
    EnterValidDate: "¡Introduzca una fecha válida!",
    EnterValidDateAdult: "Para completar la declaración, debe ser al menos",
    EnterValidDateAdultEnd: "¡años!",
    EnterValidDateKidAges: "Los niños deben estar bajo",
    PlayerName: "Nombre del jugador",
    ParentPlayerName: "Parent Player Name",
    January: "Gener",
    February: "Febrer",
    March: "Març",
    April: "Abril",
    May: "Maig",
    June: "Juny",
    July: "Juliol",
    August: "Agost",
    September: "Setembre",
    October: "Octubre",
    November: "Novembre",
    December: "Desembre",
    'Fill in a Form':'Rellenar el formulario',
    'Select Waiver':'Seleccionar consentimiento informado',
    'Select Type & Language':'Seleccione tipo',
    'Choose your Waiver!': 'CONSENTIMIENTO INFORMADO',
    'Select Language': 'Elige tu idioma',
    'Select Type': 'Selecciona una de las siguientes opciones',
    'Myself': 'Adulto',
    'Myself and Children': 'Adulto y menor',
    'Back': 'Atrás',
    "Please enter a valid number": "Introduïu un número vàlid"
}

var dictESM = {
    SAVE: "Save",
    BACK: "Trona",
    NAME: "Nom:",
    ADDRESS: "Address:",
    WAIVER: "Waiver",
    WAIVERTEXT: "Thank you for visiting! <br /> This process will allow you to digitally sign your liability waiver. <br /> note that you must be at least 18<br /> years old in order to sign a liability waiver. If you are not 18<br /> years old, please ask your parent or legal guardian to complete this procedure.",
    MYSELFCHILDREN: "Myself & Children",
    IAGREE: "I agree with these general conditions",
    FIRSTNAME: "First Name",
    LASTNAME: "Last Name",
    CITY: "City",
    PHONE: "Telèfon",
    CHILDNAME: "Child's name",
    AGE: "Age",
    BIRTDATE: "Brithday date",
    SEX: "Sex",
    ADDCHILD: "Add Child",
    CLEAR: "Clear",
    LOADING: "Cargant...",
    THANKYOU: "Thank you for signing the waiver!",
    SIGNHERE: "SIGN HERE",
    Sorry: "Please reconnect and try again.",
    Oops: "Oops! <br />Wi-Fi connection lost.",
    Sorry500: "We're sorry. Please try again.",
    Oops500: "Oops! <br />Something went wrong.",
    MoveOn: "Continue",
    orderNotes: "Comandes",
    ChooseEvent: "Choose a birthday party or event",
    tooltiptext: "If you will attend a Birthday party or event, please choose which one from the list",
    CreateFullProfile: "Setup to create basic profiles when signing a group waiver",
    EnterValidDate: "¡Introduzca una fecha válida!",
    EnterValidDateAdult: "Para completar la declaración, debe ser al menos",
    EnterValidDateAdultEnd: "¡años!",
    EnterValidDateKidAges: "Los niños deben estar bajo",
    PlayerName: "Nombre del jugador",
    ParentPlayerName: "Parent Player Name",
    January: "Gener",
    February: "Febrer",
    March: "Març",
    April: "Abril",
    May: "Maig",
    June: "Juny",
    July: "Juliol",
    August: "Agost",
    September: "Setembre",
    October: "Octubre",
    November: "Novembre",
    December: "Desembre",
    'Fill in a Form':'Rellenar el formulario',
    'Select Waiver':'Seleccionar consentimiento informado',
    'Select Type & Language':'Seleccione tipo',
    'Choose your Waiver!': 'CONSENTIMIENTO INFORMADO',
    'Select Language': 'Elige tu idioma',
    'Select Type': 'Selecciona una de las siguientes opciones',
    'Myself': 'Adulto',
    'Myself and Children': 'Adulto y menor',
    'Back': 'Atrás',
    "Please enter a valid number": "Introduïu un número vàlid"
}

var dictPT = {
    SAVE: "Save",
    BACK: "Trona",
    NAME: "Nom:",
    ADDRESS: "Address:",
    WAIVER: "Waiver",
    WAIVERTEXT: "Thank you for visiting! <br /> This process will allow you to digitally sign your liability waiver. <br /> note that you must be at least 18<br /> years old in order to sign a liability waiver. If you are not 18<br /> years old, please ask your parent or legal guardian to complete this procedure.",
    MYSELFCHILDREN: "Myself & Children",
    IAGREE: "I agree with these general conditions",
    FIRSTNAME: "First Name",
    LASTNAME: "Last Name",
    CITY: "City",
    PHONE: "Telèfon",
    CHILDNAME: "Child's name",
    AGE: "Age",
    BIRTDATE: "Brithday date",
    SEX: "Sex",
    ADDCHILD: "Add Child",
    CLEAR: "Clear",
    LOADING: "Cargant...",
    THANKYOU: "Thank you for signing the waiver!",
    SIGNHERE: "SIGN HERE",
    Sorry: "Please reconnect and try again.",
    Oops: "Oops! <br />Wi-Fi connection lost.",
    Sorry500: "We're sorry. Please try again.",
    Oops500: "Oops! <br />Something went wrong.",
    MoveOn: "Continue",
    orderNotes: "Comandes",
    ChooseEvent: "Choose a birthday party or event",
    tooltiptext: "If you will attend a Birthday party or event, please choose which one from the list",
    CreateFullProfile: "Setup to create basic profiles when signing a group waiver",
    EnterValidDate: "¡Introduzca una fecha válida!",
    EnterValidDateAdult: "Para completar la declaración, debe ser al menos",
    EnterValidDateAdultEnd: "¡años!",
    EnterValidDateKidAges: "Los niños deben estar bajo",
    PlayerName: "Nombre del jugador",
    ParentPlayerName: "Parent Player Name",
    January: "Janeiro",
    February: "Fevereiro",
    March: "Março",
    April: "Abril",
    May: "Maio",
    June: "Junho",
    July: "Julho",
    August: "Agosto",
    September: "Setembro",
    October: "Outubro",
    November: "Novembro",
    December: "Dezembro",
    'Fill in a Form':'Preencher o Formulário',
    'Select Waiver':'Selecionar Termo',
    'Select Type & Language':'Responsabilidade Selecionar Tipo',
    'Choose your Waiver!': 'CONSENTIMIENTO INFORMADO',
    'Select Language': 'Elige tu idioma',
    'Select Type': 'Selecciona una de las siguientes opciones',
    'Myself': 'Adulto',
    'Myself and Children': 'Adulto y menor',
    'Back': 'Atrás',
    "Please enter a valid number": "Por favor insira um número válido",
    "AddressField": "Endereço",
    "BackField": "Voltar",
    "BirthdateChildField": "Data de nascimento da criança",
    "BirthdateField": "Data de nascimento",
    "ChildName": "Nome da criança",
    "ChildLastName": "Sobrenome da criança",
    "CityField": "Cidade",
    "EmailField": "E-mail",
    "FirstNameField": "Nome",
    "Gender": "Gênero",
    "GenderMaleField": "Masculino",
    "GenderFemaleField": "Feminino",
    "GeneralConditionsField": "Por favor, preencha a declaração para usar as instalações.",
    "Language": "Português",
    "LastNameField": "Sobrenome",
    "Myself": "Sou maior de idade",
    "MyselfAndChildren": "Sou pai/mãe ou responsável",
    "PhoneField": "Telefone",
    "PostcodeField": "Código postal",
    "SaveField": "Salvar",
    "ButtonAddChild": "Adicionar criança",
    "ButtonClear": "Limpar",
    "ChooseYourWaiver": "Escolha a declaração",
    "ConnectionProblemMessage": "Falha na conexão com o servidor. Verifique sua conexão com a Internet!",
    "ErrorMessage": "Erro ao enviar a declaração. Por favor, entre em contato com a recepção!",
    "FillInAllFields": "Por favor, preencha todos os campos!",
    "FillInForm": "Preencha o formulário",
    "SelectLanguage": "Selecione o idioma",
    "SelectType": "Selecione o tipo",
    "SelectTypeAndLanguage": "Selecione o tipo e idioma",
    "SelectWaiver": "Selecione a declaração",
    "SuccessMessage": "Declaração preenchida com sucesso!",
    "SignatureFieldText": "Assinatura"
}

var dictIT = {
    SAVE: "Save",
    BACK: "Back",
    NAME: "Name:",
    ADDRESS: "Address:",
    WAIVER: "Waiver",
    WAIVERTEXT: "Thank you for visiting! <br /> This process will allow you to digitally sign your liability waiver. <br /> note that you must be at least 18<br /> years old in order to sign a liability waiver. If you are not 18<br /> years old, please ask your parent or legal guardian to complete this procedure.",
    MYSELFCHILDREN: "Myself & Children",
    IAGREE: "I agree with these general conditions",
    FIRSTNAME: "First Name",
    LASTNAME: "Last Name",
    CITY: "City",
    PHONE: "Phone",
    CHILDNAME: "Child's name",
    AGE: "Age",
    BIRTDATE: "Brithday date",
    SEX: "Sex",
    ADDCHILD: "Add Child",
    CLEAR: "Clear",
    LOADING: "Loading...",
    THANKYOU: "Thank you for signing the waiver!",
    SIGNHERE: "SIGN HERE",
    Sorry: "Please reconnect and try again.",
    Oops: "Oops! <br />Wi-Fi connection lost.",
    Sorry500: "We're sorry. Please try again.",
    Oops500: "Oops! <br />Something went wrong.",
    MoveOn: "Continue",
    orderNotes: "Order Notes",
    ChooseEvent: "Choose a birthday party or event",
    tooltiptext: "If you will attend a Birthday party or event, please choose which one from the list",
    CreateFullProfile: "Setup to create basic profiles when signing a group waiver",
    EnterValidDate: "Enter a valid date!",
    EnterValidDateAdult: "In order to complete the declaration, you must be at least",
    EnterValidDateAdultEnd: "years old!",
    EnterValidDateKidAges: "Children must be under",
    PlayerName: "Player Name",
    ParentPlayerName: "Parent Player Name",
    'Fill in a Form':'Fill in a Form',
    'Select Waiver':'Select Waiver',
    'Select Type & Language':'Select Type & Language',
    'Choose your Waiver!': 'Choose your Waiver!',
    'Select Language': 'Select Language',
    'Select Type': 'Select Type',
    'Myself': 'Myself',
    'Myself and Children': 'Myself and Children',
    'Back': 'Back',
    "Please enter a valid number": "Please enter a valid number",
    "AddressField": "Indirizzo",
    "BackField": "Indietro",
    "BirthdateChildField": "Data di nascita del bambino",
    "BirthdateField": "Data di nascita",
    "ChildName": "Nome del bambino",
    "ChildLastName": "Cognome del bambino",
    "CityField": "Città",
    "EmailField": "Email",
    "FirstNameField": "Nome",
    "Gender": "Genere",
    "GenderMaleField": "Maschio",
    "GenderFemaleField": "Femmina",
    "GeneralConditionsField": "Si prega di compilare la dichiarazione per utilizzare le strutture.",
    "Language": "Italiano",
    "LastNameField": "Cognome",
    "Myself": "Sono maggiorenne",
    "MyselfAndChildren": "Sono genitore/tutore",
    "PhoneField": "Telefono",
    "PostcodeField": "CAP",
    "SaveField": "Salva",
    "ButtonAddChild": "Aggiungi bambino",
    "ButtonClear": "Cancella",
    "ChooseYourWaiver": "Scegli la dichiarazione",
    "ConnectionProblemMessage": "Connessione al server fallita. Si prega di controllare la connessione a Internet!",
    "ErrorMessage": "Errore durante l'invio della dichiarazione. Contattare la reception!",
    "FillInAllFields": "Per favore, compila tutti i campi!",
    "FillInForm": "Compila il modulo",
    "SelectLanguage": "Seleziona lingua",
    "SelectType": "Seleziona tipo",
    "SelectTypeAndLanguage": "Seleziona tipo e lingua",
    "SelectWaiver": "Seleziona dichiarazione",
    "SuccessMessage": "La dichiarazione è stata completata con successo!",
    "SignatureFieldText": "Firma"
}

var dictRO = {
    SAVE: "Save",
    BACK: "Back",
    NAME: "Name:",
    ADDRESS: "Address:",
    WAIVER: "Waiver",
    WAIVERTEXT: "Thank you for visiting! <br /> This process will allow you to digitally sign your liability waiver. <br /> note that you must be at least 18<br /> years old in order to sign a liability waiver. If you are not 18<br /> years old, please ask your parent or legal guardian to complete this procedure.",
    MYSELFCHILDREN: "Myself & Children",
    IAGREE: "I agree with these general conditions",
    FIRSTNAME: "First Name",
    LASTNAME: "Last Name",
    CITY: "City",
    PHONE: "Phone",
    CHILDNAME: "Child's name",
    AGE: "Age",
    BIRTDATE: "Brithday date",
    SEX: "Sex",
    ADDCHILD: "Add Child",
    CLEAR: "Clear",
    LOADING: "Loading...",
    THANKYOU: "Thank you for signing the waiver!",
    SIGNHERE: "SIGN HERE",
    Sorry: "Please reconnect and try again.",
    Oops: "Oops! <br />Wi-Fi connection lost.",
    Sorry500: "We're sorry. Please try again.",
    Oops500: "Oops! <br />Something went wrong.",
    MoveOn: "Continue",
    orderNotes: "Order Notes",
    ChooseEvent: "Choose a birthday party or event",
    tooltiptext: "If you will attend a Birthday party or event, please choose which one from the list",
    CreateFullProfile: "Setup to create basic profiles when signing a group waiver",
    EnterValidDate: "Enter a valid date!",
    EnterValidDateAdult: "In order to complete the declaration, you must be at least",
    EnterValidDateAdultEnd: "years old!",
    EnterValidDateKidAges: "Children must be under",
    PlayerName: "Player Name",
    ParentPlayerName: "Parent Player Name",
    'Fill in a Form':'Fill in a Form',
    'Select Waiver':'Select Waiver',
    'Select Type & Language':'Select Type & Language',
    'Choose your Waiver!': 'Choose your Waiver!',
    'Select Language': 'Select Language',
    'Select Type': 'Select Type',
    'Myself': 'Myself',
    'Myself and Children': 'Myself and Children',
    'Back': 'Back',
    "Please enter a valid number": "Please enter a valid number"
}

var dictDE = {
    // SAVE: "Speichern",
    // BACK: "Zurück",
    // NAME: "Name:",
    // ADDRESS: "Adresse:",
    // WAIVER: "Haftungsverzicht",
    // WAIVERTEXT: "Vielen Dank für Ihren Besuch! <br /> Dieser Vorgang ermöglicht es Ihnen, Ihren Haftungsverzicht digital zu unterschreiben. <br /> Bitte beachten Sie, dass Sie mindestens 18<br /> Jahre alt sein müssen, um einen Haftungsverzicht zu unterschreiben. Wenn Sie unter 18<br /> Jahre alt sind, lassen Sie bitte Ihre Eltern oder Erziehungsberechtigten dieses Verfahren ausfüllen.",
    // MYSELFCHILDREN: "Ich & Kinder",
    // IAGREE: "Ich stimme diesen allgemeinen Bedingungen zu",
    // FIRSTNAME: "Vorname",
    // LASTNAME: "Nachname",
    // CITY: "Stadt",
    // PHONE: "Telefon",
    // CHILDNAME: "Name des Kindes",
    // AGE: "Alter",
    // BIRTDATE: "Geburtsdatum",
    // SEX: "Geschlecht",
    // ADDCHILD: "Kind hinzufügen",
    // CLEAR: "Löschen",
    // LOADING: "Lädt...",
    // THANKYOU: "Danke für das Unterschreiben des Haftungsverzichts!",
    // SIGNHERE: "HIER UNTERSCHREIBEN",
    // Sorry: "Bitte erneut verbinden und versuchen.",
    // Oops: "Hoppla! <br />WLAN-Verbindung verloren.",
    // Sorry500: "Es tut uns leid. Bitte versuchen Sie es erneut.",
    // Oops500: "Hoppla! <br />Etwas ist schiefgelaufen.",
    // MoveOn: "Weiter",
    // orderNotes: "Bestellhinweise",
    // ChooseEvent: "Wählen Sie eine Geburtstagsfeier oder Veranstaltung",
    // tooltiptext: "Wenn Sie an einer Geburtstagsfeier oder Veranstaltung teilnehmen, wählen Sie bitte eine aus der Liste aus",
    // CreateFullProfile: "Einrichtung zur Erstellung von Profilen beim Gruppenhaftungsverzicht",
    // EnterValidDate: "Geben Sie ein gültiges Datum ein!",
    // EnterValidDateAdult: "Um die Erklärung abzuschließen, müssen Sie mindestens",
    // EnterValidDateAdultEnd: "Jahre alt sein!",
    // EnterValidDateKidAges: "Kinder müssen unter",
    // PlayerName: "Spielername",
    // ParentPlayerName: "Name des Elternteils des Spielers",
    January: "Januar",
    February: "Februar",
    March: "März",
    April: "April",
    May: "Mai",
    June: "Juni",
    July: "Juli",
    August: "August",
    September: "September",
    October: "Oktober",
    November: "November",
    December: "Dezember",
    "SAVE" : "Speichern",
    "BACK" : "Zurück",
    "NAME" : "Name:",
    "ADDRESS" : "Adresse:",
    "WAIVER" : "Haftungsverzicht",
    "WAIVERTEXT" : "Vielen Dank für Ihren Besuch! <br /> Dieser Vorgang ermöglicht es Ihnen, Ihren Haftungsverzicht digital zu unterschreiben. <br /> Bitte beachten Sie, dass Sie mindestens 18<br /> Jahre alt sein müssen, um einen Haftungsverzicht zu unterschreiben. Wenn Sie unter 18<br /> Jahre alt sind, lassen Sie bitte Ihre Eltern oder Erziehungsberechtigten dieses Verfahren ausfüllen.",
    "MYSELFCHILDREN" : "Ich & Kinder",
    "IAGREE" : "Ich stimme diesen allgemeinen Bedingungen zu",
    "FIRSTNAME" : "Vorname",
    "LASTNAME" : "Nachname",
    "CITY" : "Stadt",
    "PHONE" : "Telefon",
    "CHILDNAME" : "Name des Kindes",
    "AGE" : "Alter",
    "BIRTDATE" : "Geburtsdatum",
    "SEX" : "Geschlecht",
    "ADDCHILD" : "Kind hinzufügen",
    "CLEAR" : "Löschen",
    "LOADING" : "Lädt...",
    "THANKYOU" : "Danke für das Unterschreiben des Haftungsverzichts!",
    "SIGNHERE" : "HIER UNTERSCHREIBEN",
    "Sorry" : "Bitte erneut verbinden und versuchen.",
    "Oops" : "Hoppla! <br />WLAN-Verbindung verloren.",
    "Sorry500" : "Es tut uns leid. Bitte versuchen Sie es erneut.",
    "Oops500" : "Hoppla! <br />Etwas ist schiefgelaufen.",
    "MoveOn" : "Weiter",
    "orderNotes" : "Bestellhinweise",
    "ChooseEvent" : "Wählen Sie eine Geburtstagsfeier oder Veranstaltung",
    "tooltiptext" : "Wenn Sie an einer Geburtstagsfeier oder Veranstaltung teilnehmen, wählen Sie bitte eine aus der Liste aus",
    "CreateFullProfile" : "Einrichtung zur Erstellung von Profilen beim Gruppenhaftungsverzicht",
    "EnterValidDate" : "Geben Sie ein gültiges Datum ein!",
    "EnterValidDateAdult" : "Um die Erklärung abzuschließen, müssen Sie mindestens",
    "EnterValidDateAdultEnd" : "Jahre alt sein!",
    "EnterValidDateKidAges" : "Kinder müssen unter",
    "PlayerName" : "Spielername",
    "ParentPlayerName" : "Name des Elternteils des Spielers",
    "Fill in a Form" : "Formular ausfüllen",
    "Select Waiver" : "Verzicht wählen",
    "Select Type & Language" : "Typ & Sprache wählen",
    "Choose your Waiver!" : "Wählen Sie Ihren Verzicht!",
    "Select Language" : "Sprache wählen",
    "Select Type" : "Typ wählen",
    "Myself" : "Ich selbst",
    "Myself and Children" : "Ich selbst und Kinder",
    "Back" : "Zurück",
    "Please enter a valid number" : "Bitte geben Sie eine gültige Zahl ein",
    "AddressField" : "Adresse",
    "BackField" : "Zurück",
    "BirthdateChildField" : "Geburtsdatum des Kindes",
    "BirthdateField" : "Geburtsdatum",
    "ChildName" : "Kindervorname",
    "ChildLastName" : "Kindernachname",
    "CityField" : "Stadt",
    "EmailField" : "E-Mail",
    "FirstNameField" : "Vorname",
    "Gender" : "Geschlecht",
    "GenderMaleField" : "Männlich",
    "GenderFemaleField" : "Weiblich",
    "GeneralConditionsField" : "Bitte füllen Sie eine Erklärung aus, um die Einrichtungen zu nutzen.",
    "LastNameField" : "Nachname",
    "Myself" : "Ich selbst",
    "MyselfAndChildren" : "Ich selbst und Kinder",
    "PhoneField" : "Telefon",
    "PostcodeField" : "Postleitzahl",
    "SaveField" : "Speichern",
    "ButtonAddChild" : "Kind hinzufügen",
    "ButtonClear" : "Löschen",
    "ChooseYourWaiver" : "Wählen Sie Ihren Verzicht",
    "ConnectionProblemMessage" : "Die Verbindung zum Server war nicht erfolgreich. Bitte überprüfen Sie Ihre Internetverbindung!",
    "ErrorMessage" : "Beim Senden der Erklärung ist ein Fehler aufgetreten. Bitte wenden Sie sich an die Rezeption!",
    "FillInAllFields" : "Bitte füllen Sie alle Felder aus!",
    "FillInForm" : "Formular ausfüllen",
    "SelectLanguage" : "Sprache wählen",
    "SelectType" : "Typ wählen",
    "SelectTypeAndLanguage" : "Typ und Sprache wählen",
    "SelectWaiver" : "Verzicht wählen",
    "SuccessMessage" : "Das Ausfüllen der Erklärung war erfolgreich!",
    "SignatureFieldText" : "Unterschrift",
    "English": "Englisch",
    "Deutch": "Deutsch",
    "Spanish": "Spanisch",
}

var dictLT = {
    SAVE: "Save",
    BACK: "Back",
    NAME: "Name:",
    ADDRESS: "Address:",
    WAIVER: "Waiver",
    WAIVERTEXT: "Thank you for visiting! <br /> This process will allow you to digitally sign your liability waiver. <br /> note that you must be at least 18<br /> years old in order to sign a liability waiver. If you are not 18<br /> years old, please ask your parent or legal guardian to complete this procedure.",
    MYSELFCHILDREN: "Myself & Children",
    IAGREE: "I agree with these general conditions",
    FIRSTNAME: "First Name",
    LASTNAME: "Last Name",
    CITY: "City",
    PHONE: "Phone",
    CHILDNAME: "Child's name",
    AGE: "Age",
    BIRTDATE: "Brithday date",
    SEX: "Sex",
    ADDCHILD: "Add Child",
    CLEAR: "Clear",
    LOADING: "Loading...",
    THANKYOU: "Thank you for signing the waiver!",
    SIGNHERE: "SIGN HERE",
    Sorry: "Please reconnect and try again.",
    Oops: "Oops! <br />Wi-Fi connection lost.",
    Sorry500: "We're sorry. Please try again.",
    Oops500: "Oops! <br />Something went wrong.",
    MoveOn: "Continue",
    orderNotes: "Order Notes",
    ChooseEvent: "Choose a birthday party or event",
    tooltiptext: "If you will attend a Birthday party or event, please choose which one from the list",
    CreateFullProfile: "Setup to create basic profiles when signing a group waiver",
    EnterValidDate: "Enter a valid date!",
    EnterValidDateAdult: "In order to complete the declaration, you must be at least",
    EnterValidDateAdultEnd: "years old!",
    EnterValidDateKidAges: "Children must be under",
    PlayerName: "Player Name",
    ParentPlayerName: "Parent Player Name",
    'Fill in a Form':'Fill in a Form',
    'Select Waiver':'Select Waiver',
    'Select Type & Language':'Select Type & Language',
    'Choose your Waiver!': 'Choose your Waiver!',
    'Select Language': 'Select Language',
    'Select Type': 'Select Type',
    'Myself': 'Myself',
    'Myself and Children': 'Myself and Children',
    'Back': 'Back',
    "Please enter a valid number": "Please enter a valid number",
    "AddressField": "Address",
    "BackField": "Back",
    "BirthdateChildField": "Child Birthdate",
    "BirthdateField": "Birthdate",
    "ChildName": "Child Name",
    "ChildLastName": "Child Last Name",
    "CityField": "City",
    "EmailField": "Email",
    "FirstNameField": "First Name",
    "Gender": "Gender",
    "GenderMaleField": "Male",
    "GenderFemaleField": "Female",
    "GeneralConditionsField": "Please fill out a declaration to use the facilities in the hall.",
    "LastNameField": "Last Name",
    "Myself": "Myself",
    "MyselfAndChildren": "Myself and Children",
    "PhoneField": "Phone",
    "PostcodeField": "Post code",
    "SaveField": "Save",
    "ButtonAddChild": "Add Child",
    "ButtonClear": "Clear",
    "ChooseYourWaiver": "Choose your Waiver",
    "ConnectionProblemMessage": "The connection to the server was unsuccessful. Please check your Internet connection!",
    "ErrorMessage": "There was an error sending the declaration. Please contact reception!",
    "FillInAllFields": "Please fill in all fields!",
    "FillInForm": "Fill out a form",
    "SelectLanguage": "Select Language",
    "SelectType": "Select Type",
    "SelectTypeAndLanguage": "Select Type and Language",
    "SelectWaiver": "Select Waiver",
    "SuccessMessage": "Filling out the declaration was successful!",
    "SignatureFieldText": "Signature",
}

var dictID = {
    SAVE: "Save",
    BACK: "Back",
    NAME: "Name:",
    ADDRESS: "Address:",
    WAIVER: "Waiver",
    WAIVERTEXT: "Thank you for visiting! <br /> This process will allow you to digitally sign your liability waiver. <br /> note that you must be at least 18<br /> years old in order to sign a liability waiver. If you are not 18<br /> years old, please ask your parent or legal guardian to complete this procedure.",
    MYSELFCHILDREN: "Myself & Children",
    IAGREE: "I agree with these general conditions",
    FIRSTNAME: "First Name",
    LASTNAME: "Last Name",
    CITY: "City",
    PHONE: "Phone",
    CHILDNAME: "Child's name",
    AGE: "Age",
    BIRTDATE: "Brithday date",
    SEX: "Sex",
    ADDCHILD: "Add Child",
    CLEAR: "Clear",
    LOADING: "Loading...",
    THANKYOU: "Thank you for signing the waiver!",
    SIGNHERE: "SIGN HERE",
    Sorry: "Please reconnect and try again.",
    Oops: "Oops! <br />Wi-Fi connection lost.",
    Sorry500: "We're sorry. Please try again.",
    Oops500: "Oops! <br />Something went wrong.",
    MoveOn: "Continue",
    orderNotes: "Order Notes",
    ChooseEvent: "Choose a birthday party or event",
    tooltiptext: "If you will attend a Birthday party or event, please choose which one from the list",
    CreateFullProfile: "Setup to create basic profiles when signing a group waiver",
    EnterValidDate: "Enter a valid date!",
    EnterValidDateAdult: "In order to complete the declaration, you must be at least",
    EnterValidDateAdultEnd: "years old!",
    EnterValidDateKidAges: "Children must be under",
    PlayerName: "Player Name",
    ParentPlayerName: "Parent Player Name",
    'Fill in a Form':'Fill in a Form',
    'Select Waiver':'Select Waiver',
    'Select Type & Language':'Select Type & Language',
    'Choose your Waiver!': 'Choose your Waiver!',
    'Select Language': 'Select Language',
    'Select Type': 'Select Type',
    'Myself': 'Myself',
    'Myself and Children': 'Myself and Children',
    'Back': 'Back',
    "Please enter a valid number": "Please enter a valid number",
    "AddressField": "Address",
    "BackField": "Back",
    "BirthdateChildField": "Child Birthdate",
    "BirthdateField": "Birthdate",
    "ChildName": "Child Name",
    "ChildLastName": "Child Last Name",
    "CityField": "City",
    "EmailField": "Email",
    "FirstNameField": "First Name",
    "Gender": "Gender",
    "GenderMaleField": "Male",
    "GenderFemaleField": "Female",
    "GeneralConditionsField": "Please fill out a declaration to use the facilities in the hall.",
    "LastNameField": "Last Name",
    "Myself": "Myself",
    "MyselfAndChildren": "Myself and Children",
    "PhoneField": "Phone",
    "PostcodeField": "Post code",
    "SaveField": "Save",
    "ButtonAddChild": "Add Child",
    "ButtonClear": "Clear",
    "ChooseYourWaiver": "Choose your Waiver",
    "ConnectionProblemMessage": "The connection to the server was unsuccessful. Please check your Internet connection!",
    "ErrorMessage": "There was an error sending the declaration. Please contact reception!",
    "FillInAllFields": "Please fill in all fields!",
    "FillInForm": "Fill out a form",
    "SelectLanguage": "Select Language",
    "SelectType": "Select Type",
    "SelectTypeAndLanguage": "Select Type and Language",
    "SelectWaiver": "Select Waiver",
    "SuccessMessage": "Filling out the declaration was successful!",
    "SignatureFieldText": "Signature",
}